import alert from '@/plugins/alert'
import { Bill } from '@/plugins/api'

export default {
  namespaced: true,
  state: {
    bills: {},
    bill: {},
    count: 0
  },
  actions: {
    async fetchBill ({ commit }, billId) {
      commit('setBill', await Bill.fetchOne(billId))
    },
    // api is create or update. If record exist then create.
    async createBill ({ commit }, { data, options }) {
      commit('setBill', await Bill.create(data, options))
      alert.success('Cập nhật thành công!')
    },
    async removeBill ({ commit }, id) {
      await Bill.remove(id)
      commit('removeBill', id)
      alert.success('Xóa thành công!')
    },
    setBill ({ commit, state }, bill) {
      commit('setBill', bill)
    },
    async updateBill ({ commit, state }, { id, ...bill }) {
      try {
        commit('setBill', await Bill.update(id, bill))
        alert.success('Cập nhật thành công!')
      } catch (e) {
        alert.error(e)
      }
    }
  },
  mutations: {
    setBill (state, bill) {
      state.bill = bill
    },
    removeBill (state, billId) {
      delete state.bills[billId]
      state.bills = { ...state.bills }
    }
  },
  getters: {
    bill: (state) => {
      return state.bill
    }
  }
}
